import { render, staticRenderFns } from "./MiniAbsenceAdministration.vue?vue&type=template&id=a4163ffa"
import script from "./MiniAbsenceAdministration.vue?vue&type=script&lang=js"
export * from "./MiniAbsenceAdministration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDataTable,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4163ffa')) {
      api.createRecord('a4163ffa', component.options)
    } else {
      api.reload('a4163ffa', component.options)
    }
    module.hot.accept("./MiniAbsenceAdministration.vue?vue&type=template&id=a4163ffa", function () {
      api.rerender('a4163ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Administration/MiniAbsenceAdministration.vue"
export default component.exports